import React, { useState } from "react";
import useStore from "../../../context/useStore";
import OverlayContent from "../../common/OverlayContent";
import PaymentTablePdf from "./PaymentTablePdf";
import useTVA from "../../../hooks/useInit/useTVA";
import { buildRecapRows, buildRecapFileName, fmtEuro } from "./recapData";
import styles from "./PaymentTable.module.scss";

const PaymentTable = ({ quotations, finances, showPrintButton = true }) => {
  const [state] = useStore();
  const [pdfOpen, setPdfOpen] = useState(false);
  const [fileName, setFileName] = useState("");
  const constantData = state.constant.items;
  const { getTVAByCatalog } = useTVA();

  const rows = buildRecapRows({
    finances,
    quotationSources: quotations,
    constantData,
    getTVAByCatalog,
  });

  const getLine = (row, k) => {
    const content = [];
    for (let i = 0; i < row.quantity; i++) {
      content.push(
        <tr key={"qline" + k + i} className={styles.row}>
          <td className={styles.vehicle}>{row.reference}</td>
          <td>{row.typeName}</td>
          <td className={styles.num}>{fmtEuro(row.priceHT)}</td>
          <td className={styles.num}>{fmtEuro(row.optHT)}</td>
          <td className={styles.num}>{fmtEuro(row.marHT)}</td>
          <td className={styles.num}>{fmtEuro(row.cgCarb)}</td>
          <td className={styles.num}>{fmtEuro(row.bm)}</td>
          <td className={styles.num}>{fmtEuro(row.tva)}</td>
          <td className={`${styles.num} ${styles.total}`}>
            {fmtEuro(row.priceTTC)}
          </td>
          <td className={`${styles.num} ${styles.total}`}>
            {fmtEuro(row.investAmtHT)}
          </td>
          <td className={styles.paliersCell}>
            {row.periods.map((p, pk) => {
              const isLast = pk === row.periods.length - 1;
              const vr = isLast ? p.residualValue : p.vr;
              const hasDuration = p.duration !== "" && p.duration != null;
              return (
                <div className={styles.palier} key={"ln" + k + pk}>
                  <span className={styles.palierBadge}>
                    P{p.num}
                    {hasDuration ? ` · ${p.duration}m` : ""}
                  </span>
                  <span className={styles.palierVr}>VR {fmtEuro(vr || 0)}</span>
                  <span className={styles.palierMens}>
                    {fmtEuro(p.monthPayment || 0)}/m
                  </span>
                </div>
              );
            })}
          </td>
        </tr>
      );
    }
    return content;
  };

  return (
    <>
      {pdfOpen && (
        <OverlayContent close={() => setPdfOpen(false)}>
          <PaymentTablePdf rows={rows} title={fileName} />
        </OverlayContent>
      )}
      {showPrintButton && (
        <button
          className={styles.printBtn}
          onClick={() => {
            setFileName(buildRecapFileName(finances?.reference || finances?.uuid));
            setPdfOpen(true);
          }}
          disabled={rows.length === 0}
        >
          <i className="fa fa-print" style={{ marginRight: 6 }} />
          Imprimer le tableau
        </button>
      )}
      <div className={styles.tableScroll}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Véhicule</th>
              <th>Type</th>
              <th className={styles.num}>Prix net HT</th>
              <th className={styles.num}>Options HT</th>
              <th className={styles.num}>MAR HT</th>
              <th className={styles.num}>CG + Carburant</th>
              <th className={styles.num}>Bonus/Malus</th>
              <th className={styles.num}>TVA</th>
              <th className={styles.num}>Prix net TTC</th>
              <th className={styles.num}>Montant invest HT</th>
              <th>Paliers</th>
            </tr>
          </thead>
          <tbody>{rows.map((row, k) => getLine(row, k))}</tbody>
        </table>
      </div>
    </>
  );
};

export default PaymentTable;
